import { isRelationalReport, isJourneyReport, isMultiConfigReport } from 'reporting-data/tsTypes/reportTypes';
import DateRangeEditor from './DateRangeEditor';
import FrequencyEditor from './FrequencyEditor';
// @ts-expect-error Untyped dependency
import FilterEditor from './FilterEditor';
import DatePropertyEditor from './DatePropertyEditor';
// @ts-expect-error Untyped dependency
import FunnelPipelineEditor from './FunnelPipelineEditor';
// @ts-expect-error Untyped dependency
import CompareEditor from './CompareEditor';
// @ts-expect-error Untyped dependency
import SnowflakeEditor from './SnowflakeEditor';
import { getCustomWidgetType } from 'reporting-data/report/reportGetters';
import GoalEditor from './GoalEditor/GoalEditor';
import JourneyDateRangePicker from './JourneyDateRangeEditor/JourneyDateRangePicker';
import JourneyDropoffEditor from './JourneyDropoffEditor';
import JourneyAnonVisitorsEditor from './JourneyAnonVisitorsEditor/index';
import MultiCurrencyEditor from './MultiCurrencyEditor/MultiCurrencyEditor';
import JourneyPropertyFilterEditor from './JourneyPropertyFilterEditor/index';
import JourneyListFilterEditor from './JourneyListFilterEditor/index';
import SecondaryDateRangeEditor from './SecondaryDateRangeEditor';
// @ts-expect-error Untyped dependency
import UnifiedAnalyticsViewFilterEditor from './UnifiedAnalyticsViewFilterEditor/UnifiedAnalyticsViewFilterEditor';
import SalesQuotaViewEditor from './SalesQuotaViewEditor';
import UnifiedEventQLEventEditor from './UnifiedEventQLEventEditor';
import JourneyPipelineStageEditor from './PipelineStageOrderEditor/JourneyPipelineStageEditor';
import ContactListEditor from './ContactListEditor';
import JourneyAssociatedEventEditor from './JourneyAssociatedEventEditor';
const MAX_REPORT_CONFIGS_FOR_DATE_FILTER = 4;
const widgetEditors = {
  DATA_LAYER: [DatePropertyEditor, SecondaryDateRangeEditor, DateRangeEditor, FrequencyEditor, CompareEditor, SalesQuotaViewEditor, MultiCurrencyEditor, GoalEditor, ContactListEditor, FunnelPipelineEditor, UnifiedAnalyticsViewFilterEditor, FilterEditor, UnifiedEventQLEventEditor],
  DEAL_FORECAST: [DatePropertyEditor, DateRangeEditor, FilterEditor],
  ENGAGEMENT_STREAM: [DateRangeEditor, FilterEditor],
  MARKETING_PERFORMANCE: [DateRangeEditor, FrequencyEditor, CompareEditor],
  PERSONA: [DatePropertyEditor, DateRangeEditor, FilterEditor],
  TASKS_STREAM: [DateRangeEditor]
};
export const getWidgetEditors = report => {
  if (isJourneyReport(report)) {
    return [JourneyDateRangePicker, JourneyDropoffEditor, JourneyAnonVisitorsEditor, JourneyPropertyFilterEditor, JourneyListFilterEditor, JourneyPipelineStageEditor, JourneyAssociatedEventEditor];
  }
  if (isRelationalReport(report)) {
    return [SnowflakeEditor];
  }
  if (isMultiConfigReport(report) && report.get('reportConfigs').size > MAX_REPORT_CONFIGS_FOR_DATE_FILTER) {
    widgetEditors['DATA_LAYER'] = widgetEditors['DATA_LAYER'].filter(editor => editor !== DatePropertyEditor);
  }
  const customWidgetType = getCustomWidgetType(report);
  return customWidgetType && widgetEditors[customWidgetType] ? widgetEditors[customWidgetType] : widgetEditors['DATA_LAYER'];
};